import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { selectors as ChannelsSelectors } from 'data/channels'
import { selectors as UsersSelectors } from 'data/users'
import classNames from 'classnames'
import { Text } from 'components/base'
import ChannelList from 'components/Channels/List'

import { canCreateNote } from 'remote/channels/roles'
import { getChannelLabel } from 'data/channels/helpers'

class ChannelListContainer extends React.Component {
  static propTypes = {
    onChannelSelected: PropTypes.func,
    channels: PropTypes.object.isRequired,
  }

  static defaultProps = {
    channels: [],
    onChannelSelected: () => {},
  }

  render() {
    const { onChannelSelected, channels } = this.props

    return (
      <React.Fragment>
        <Text.Title className="margin-bottom-small">
          Destination channel
        </Text.Title>
        <Text.Corpus className="margin-bottom-large">
          Before selecting the import service, pick the channel you want your
          documents to be imported in.
        </Text.Corpus>
        <div
          className={classNames([
            'radius-normal border-small border-shade-40 height-full padding-bottom-small',
          ])}
        >
          <ChannelList
            displaySearchBox={true}
            style={{ maxHeight: 300 }}
            channelList={channels.toArray()}
            onChannelSelected={onChannelSelected}
          />
        </div>
      </React.Fragment>
    )
  }
}

export default connect(function(state) {
  const user = UsersSelectors.getCurrentUser(state)
  const channels = ChannelsSelectors.getChannels(state)

  return {
    channels: channels
      .filter(channel => canCreateNote({ channel, user }))
      .sort((a, b) => getChannelLabel(a).localeCompare(getChannelLabel(b))),
  }
})(ChannelListContainer)
